module.exports = __webpack_public_path__ + "media/images/photo/plans/places/tsurumi_ryokuchi_park-3dbac0a767d75662a450c66bf18658df.png";